import { AkaThemaId } from '../dtos.ts';

export function assertAkaThemaId(akaThemaId: unknown): asserts akaThemaId is AkaThemaId {
  if (!isAkaThemaId(akaThemaId)) {
    throw new TypeError(`Given value "${String(akaThemaId)}" is not of type AkaThemaId`);
  }
}

export function isAkaThemaId(akaThemaId: unknown): akaThemaId is AkaThemaId {
  return typeof akaThemaId === 'string' && akaThemaId.startsWith('T');
}
